<div class="db-booster-update">
  <h1>Latest version of 10Web Booster is required</h1>
  <p class="mt10">Test mode is only available on the newest version of 10Web Booster.<br/> Please update the plugin from WordPress plugin list to use the feature.</p>
  <div class="db-booster-update__buttons mt30">
    <a class="ds-btn mr20" (click)="close()" ><span>CANCEL</span></a>
    <a class="ds-btn-blue" *ngIf="websiteConnectedFrom !== 'speed_optimizer'"
            target="_blank" rel="noopener" dbWpLink [adminLink]="adminPluginsUrl" [websiteId]="websiteId"
            (click)="confirm()">
      <span>Update</span>
    </a>
    <a class="ds-btn-blue" *ngIf="websiteConnectedFrom === 'speed_optimizer'"
            target="_blank" rel="noopener"  [href]="adminPluginsUrl"
            (click)="confirm()">
      <span>Update</span>
    </a>
  </div>
</div>
